import type { ReactNode } from "react";

/**
 * s236 (D-236.87, Reade 19:04 — approved under rule 159 as a REUSABLE piece; CARE-SHEET-1's faith line will use it) — a
 * row's SECOND LINE: follow-up questions drawn under the row, each a label beside its control, as every board draws
 * `row.line2` (`Main.dc.html` — `display: flex; align-items: center; gap: 14px; padding: 0 2px 10px 38px; flex-wrap: wrap`,
 * each item `align-items: flex-start; gap: 10px`, its label 13px, the picker at least 220px). The controls are the
 * product's existing cells (ConsequencePicker, …); this piece only lays them out. It renders in the row's `panels`, so a
 * folded row hides it like any other second line.
 */
export type SecondLineItem = { key: string; label?: string; control: ReactNode; hint?: string };

export function SecondLine({ items, testId }: { items: readonly SecondLineItem[]; testId?: string }) {
  if (items.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-[14px] pb-2.5 pl-[38px] pr-0.5" data-testid={testId}>
      {items.map((it) => (
        <div key={it.key} className="flex items-start gap-2.5" data-testid={testId ? `${testId}-${it.key}` : undefined}>
          {it.label && <span className="whitespace-nowrap pt-3 text-[13px] text-warm-charcoal">{it.label}</span>}
          <div className="min-w-[220px]">{it.control}</div>
          {it.hint && <span className="pt-3 text-[13px] text-warm-muted">{it.hint}</span>}
        </div>
      ))}
    </div>
  );
}
